<template>
  <div data-testid="user-permission" class="">
    <div class="pa-6 d-flex flex-column gap-6 pb-16">
      <UserPermissionHeader
        data-testid="user-permission__header"
        :loading="loading"
        :is-user-permissions-enabled="isUserPermissionsEnabled"
        @refresh="refreshData"
        @bulk-upload-click="onAddPermissionsClick"
      />
      <v-card class="pa-3 reportingcard d-flex flex-column gap-4"  data-testid="my-reporting-units__card" rounded-xl evlevation="0"> 
        <div class="d-flex flex-column gap-3">
          <UserPermissionUserCount :userDataSummary="userPermissionsSummary" />
          <UserPermissionTable 
            :headers="headers" 
            :items="formatedData" 
            :loading="loading" 
          />
        </div>
      </v-card>      
    </div>

      <UserPermissionBulkUploadDialog 
         v-model="drawer"
         :items="csvData"
         :headers="csvHeaders"
         :loading="bulkUploadLoading"
         :file="file"
         @process-file="updateFilesBulk"
         @download-template="downloadTemplate"
         @reset-data="resetUploadData"
         @upload-data="handleUploadBulkUsers"
      />
      
      <lb-dialog data-testid="user-permission__edit-role-dialog" v-model="dialog" heading="Change user role" width="400" :loading="dialogloading">
        <template v-slot:body>
          <div data-testid="user-permission__edit-role-body">
            <div data-testid="user-permission__selected-user-info" class="font-size-md mb-2">{{selecteduser?.name}} - {{selecteduser?.email}} </div>
            <v-radio-group data-testid="user-permission__role-radio-group" v-model="selectedrole" class="pt-0 mt-0" dense hide-details>
              <v-radio data-testid="user-permission__role-radio" v-for="(v, i) in roles" :key="i" class="my-0" :value="i">
                <template v-slot:label>
                  <span data-testid="user-permission__role-label">{{ v.name }}</span>
                </template>
              </v-radio>
            </v-radio-group>

          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn data-testid="user-permission__update-role-btn" color="primary" @click="updateUserRoleChange()"><span>Update</span></v-btn>
        </template>
      </lb-dialog>


      <lb-dialog data-testid="user-permission__view-details-dialog" v-model="viewUserDetailsdialog" class="noTransform" :heading="`User ${$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')} access details`" width="1200" :loading="viewUserDetailsdialogloading">
        <template v-slot:body>
          <div data-testid="user-permission__view-details-body">
            <MyReportingUnits data-testid="user-permission__reporting-units" :isViewOnly="true" :key="new Date().getTime()" :selectedUserId="selectedUserDetails?.userid"></MyReportingUnits>
          </div>
        </template>
      </lb-dialog>


  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MyReportingUnits from '../MyReportingUnit/MyReportingUnits.vue';
import UserPermissionHeader from './components/UserPermissionHeader.vue';
import UserPermissionUserCount from './components/UserPermissionUserCount.vue';
import UserPermissionTable from './components/UserPermissionTable.vue';
import UserPermissionBulkUploadDialog from './components/UserPermissionBulkUploadDialog.vue';

export default {
  name: 'varienceanalysis_permission_user',
  // props: ['props'],
  data: function(){
    return {
      loading: false,
      viewdialog: false,
      drawer: false,
      viewloading: false,
      viewdata: {},
      dialog: false,
      dialogloading: false,
      selectedrole: "",
      selecteduser: {},
      userid: "",
      headers: [
        {
          value: "indexno",
          text: "S.No",
          sortable: false,
          filterable: false,
          width: "70px",
          align: "center",
          cellClass: "text-center"
        },
        {
          value: "email",
          text: "Email",
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "name",
          text: "User Name",
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "role",
          text: "Role",
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "status",
          text: "Status",
          sortable: false,
          filterable: true,
          lock: true,
        },
      ],
      viewUserDetailsdialog:false,
      viewUserDetailsdialogloading:false,
      selectedUserDetails:{},
    }
  },
  components: {
    MyReportingUnits,
    UserPermissionHeader,
    UserPermissionUserCount,
    UserPermissionTable,
    UserPermissionBulkUploadDialog,
  },
  activated() {
    this.initialLoad();
  },
  mounted() {
    this.initialLoad();
  },
  methods: {
    ...mapActions('varianceanalysis/userpermission', [
      'processFilesBulk',
      'resetUploadData',
      'setShowDataWithError',
      'uploadBulkUsers',
      'fetchUserPermissions'
    ]),
    onAddPermissionsClick() {
      this.drawer = true;
      this.resetUploadData();
      this.setShowDataWithError(false);
    },

    initialLoad() {
       this.userid = this.$store.state.user.id;
       this.getData(false); // Use cache if available
    },

    refreshData() {
      this.userid = this.$store.state.user.id;
      this.getData(true); // Force refresh
    },
    setLoading(v) {
      this.loading = !!v;
    },
    editRole(user){
      this.selectedrole = user.role_id;
      this.selecteduser = user;
      this.dialog = true;
      this.dialogloading = false;
    },
    async getData(force = false) {
      this.loading = true;
      try {
        await this.fetchUserPermissions({ axiosInstance: this.axios, force });
      } catch(err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    updateUserRoleChange() {
      this.dialogloading = true;
      this.axios.post("/v2/varianceanalysis/userpermission/edit/"+this.selecteduser._id, {data: {role: [this.selectedrole]}}).then(dt => {
        if(dt.data.status === "success") {
          this.$store.commit("sbSuccess","User permissions updated successfully");
          // Refresh data forcefully to update component
          this.getData(true);
          this.dialog = false;
        }else throw new Error ("Error updating role");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.dialogloading = false;
      })
    },
    editData(item){
      this.viewdata = {...item};
    },
    openUserRUDetails(item){
      this.selectedUserDetails = item 
    },
    /**
     * Handles bulk file upload by dispatching to Vuex action
     * @param {Array} files - Array of files to process
     */
    updateFilesBulk(files) {
      this.processFilesBulk(files);
    },
    downloadTemplate() {
      this.$nova.downloadFile('', {}, '/v2/varianceanalysis/userpermission/exportUserSecurityReport');
    },
    /**
     * Handles bulk user upload by dispatching to Vuex action
     * Closes drawer and refreshes data on success
     */
    async handleUploadBulkUsers() {
      const success = await this.uploadBulkUsers({
        axios: this.axios,
        clientId: this.$store.state.client._id
      });
      
      if (success) {
        this.drawer = false;
        this.refreshData();
      }
    },
  },
  computed: {
    ...mapGetters({
      isUserPermissionsEnabled: 'isUserPermissionsEnabled',
    }),
    ...mapGetters('varianceanalysis/userpermission', {
      uploaddata: 'getUploadData',
      file: 'getFile',
      csvHeaders: 'getCsvHeaders',
      csvData: 'getCsvData',
      filteredCsvData: 'getFilteredCsvData',
      hasValidationErrors: 'hasValidationErrors',
      bulkUploadLoading: 'getBulkUploadLoading',
      userPermissionsList: 'getUserPermissionsList',
      userPermissionsRoles: 'getUserPermissionsRoles',
      userPermissionsSummary: 'getUserPermissionsSummary',
    }),
    roles() {
      const troles = this.userPermissionsRoles || [];
      const rolesMap = {};
      const colors = this.$nova.getColors(troles.length, 0.2);
      troles.forEach((el, i) => {
        rolesMap[el._id] = { name: el.name, color: colors[i] };
      });
      return rolesMap;
    },
    formatedData() {
      return (this.userPermissionsList || []).map((i, k) => ({
          __key: k,
          __formatedkey: k,
          _id: i._id,
          indexno: k + 1,
          userid: i.userid || "",
          email: i.user_detail?.contactemail || "",
          name: i.user_detail?.name || "NA",
          role_id: i.role[0] || "",
          role: this.roles[i.role[0] || ""]?.name,
          status: i.status === true ? 'Active' : 'Inactive',
          __click: "userpermission/userpermissionaddaccess/" + encodeURIComponent(i.userid),
      }));
    },
    user_permissions_superadmin() {
      return this.$store.state.user_permissions_superadmin || false;
    },
    showdatawitherror: {
      get() {
        return this.$store.getters['varianceanalysis/userpermission/getShowDataWithError'];
      },
      set(value) {
        this.setShowDataWithError(value);
      }
    }
  },
  watch: {
  }
}
</script>

<style scoped>
/* .subs-icon{
  background-color: var(--v-primary-base) !important;
  color: white;
} */
</style>